import { render, staticRenderFns } from "./MaterialMgt.vue?vue&type=template&id=6c3beae2&"
import script from "./MaterialMgt.vue?vue&type=script&lang=js&"
export * from "./MaterialMgt.vue?vue&type=script&lang=js&"
import style0 from "./MaterialMgt.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports